import backend from '../../components/utils/backend'
import { keyBy } from '../../components/utils/utils'

export default {
  state: {
    exclusionSlots: [],
    pressureRules: [],
    timingSlots: []
  },
  mutations: {
    'SET_EXCLUSION_SLOTS': function (state, slots) {
      state.exclusionSlots = slots
    },
    'SET_PRESSURE_RULES': function (state, rules) {
      state.pressureRules = rules
    },
    'SET_TIMING_SLOTS': function (state, slots) {
      state.timingSlots = slots
    }
  },
  actions: {
    getExclusionSlots ({ commit, rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await backend.get('/api/v1/calendar/exclusion-slot', rootGetters['session/accessToken'])
          if (response.statusCode !== 200) {
            console.error('Error during reading exclusion slots', response.body)
            throw new Error(response.body.moreInformation)
          } else {
            const slots = response.body
            commit('SET_EXCLUSION_SLOTS', slots)
            resolve(slots)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    deleteExclusionSlot ({ rootGetters }, slotId) {
      return new Promise(async (resolve, reject) => {
        try {
          await backend.delete(`/api/v1/calendar/exclusion-slot/${slotId}`, rootGetters['session/accessToken'])
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    saveExclusionSlot ({ rootGetters }, slot) {
      return new Promise(async (resolve, reject) => {
        try {
          await backend.post(`/api/v1/calendar/exclusion-slot/`, rootGetters['session/accessToken'], slot)
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    deleteTimingSlot ({ rootGetters }, slot) {
      return new Promise(async (resolve, reject) => {
        try {
          await backend.delete(`/api/v1/calendar/timing-slot/${slot.id}`, rootGetters['session/accessToken'])
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    getTimingSlots ({ commit, rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await backend.get('/api/v1/calendar/timing-slot', rootGetters['session/accessToken'])

          if (response.statusCode !== 200) {
            console.error('Error during reading timing slots', response.body)
            throw new Error(response.body.moreInformation)
          } else {
            const slots = response.body
            commit('SET_EXCLUSION_SLOTS', slots)
            resolve(slots)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    upsertTimingSlots ({ rootGetters }, slot) {
      return new Promise(async (resolve, reject) => {
        try {
          if (slot.id) {
            await backend.put(`/api/v1/calendar/timing-slot/${slot.id}`, rootGetters['session/accessToken'], slot)
          } else {
            await backend.post(`/api/v1/calendar/timing-slot/`, rootGetters['session/accessToken'], slot)
          }
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    getPressureRules ({ commit, rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const slots = (await backend.get('/api/v1/calendar/pressure-rule', rootGetters['session/accessToken'])).body
          const keyedByMarket = keyBy(slots, 'codMarket')
          const keyedByMarketAndChannel = {}
          Object.keys(keyedByMarket).map(key => {
            const value = keyedByMarket[key]
            keyedByMarketAndChannel[key] = keyBy(value, 'channel')
          })

          commit('SET_PRESSURE_RULES', keyedByMarketAndChannel)
          resolve(keyedByMarketAndChannel)
        } catch (error) {
          reject(error)
        }
      })
    },
    upsertPressureRule ({ rootGetters }, rule) {
      return new Promise(async (resolve, reject) => {
        try {
          if (rule.id) {
            await backend.put(`/api/v1/calendar/pressure-rule/${rule.id}`, rootGetters['session/accessToken'], rule)
          } else {
            await backend.post(`/api/v1/calendar/pressure-rule/`, rootGetters['session/accessToken'], rule)
          }
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    }
  },
  getters: {
    timingSlots: state => state.timingSlots
  },
  namespaced: true
}
